import { sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackSEOCopyToggle = ({ heading, open }: { heading: string; open: boolean }) => {
  sendGAEvent({
    event: 'custom_event',
    event_category: 'Category page',
    event_action: `SEO copy - ${open ? 'see more' : 'see less'}`,
    event_label: `category - ${heading}`,
  });
};
